// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__card___uzT9P {
  background: white;
}

.styles__title___jMqj9 {
}

.styles__address___AD94m {
  padding: 12px 20px;
  font-size: 14px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  opacity: 0.9;
}

.styles__singleLine___OhOWm {
  display: flex;
  width: 100%;
  height: 32px;
  padding: 0 20px;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]};
}

.styles__label___WfPiB,
.styles__value___KbVlh {
  font-size: 14px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Subaccounts/VehicleInfoSection/styles.css"],"names":[],"mappings":"AAIA;EAEE,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mDAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,kEAAsC;AACxC;;AAEA;;EAEE,eAAe;EACf,mDAAW;EACX,YAAY;AACd","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value borderColorLight, text from colors;\n\n.card {\n  composes: cardMarginBot from helpers;\n  background: white;\n}\n\n.title {\n  composes: sectionTitle from helpers;\n}\n\n.address {\n  padding: 12px 20px;\n  font-size: 14px;\n  color: text;\n  opacity: 0.9;\n}\n\n.singleLine {\n  display: flex;\n  width: 100%;\n  height: 32px;\n  padding: 0 20px;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid borderColorLight;\n}\n\n.label,\n.value {\n  font-size: 14px;\n  color: text;\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"borderColorLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"card": `styles__card___uzT9P ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"title": `styles__title___jMqj9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"address": `styles__address___AD94m`,
	"singleLine": `styles__singleLine___OhOWm`,
	"label": `styles__label___WfPiB`,
	"value": `styles__value___KbVlh`
};
export default ___CSS_LOADER_EXPORT___;
